import { render, staticRenderFns } from "./StockTransferList.vue?vue&type=template&id=6738696a"
import script from "./StockTransferList.vue?vue&type=script&lang=js"
export * from "./StockTransferList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports